<form [formGroup]="searchForm">
    <!-- <div class="row article-search-div" role="search" *ngIf="!selectDiv"> -->
    <div class="row article-search-div" role="search">
        <div class="col-8 col-sm-8 col-md-10 col-lg-10 col-xl-10 search-box-col">
            <div class="input-group search-box">
                <div class="input-group-append search-icon-div">
                    <span class="input-group-text" >
                        <!-- <i class="bi bi-search"></i> -->
                        <fa-icon [icon]="['fas','magnifying-glass']" aria-hidden="true" ></fa-icon>
                    </span>
                </div>
                <input type="text" class="form-control text-box search-box searchplaceholder" name="searchValue" formControlName="searchValue"
                    placeholder="Enter keyword, title, author or ISBN" aria-label="search"
                     (keyup)="searchArticle()" (focusout)="searchLoader = false;"
                    (click)="searchArticle()">
                <div *ngIf="searchLoader">
                    <div class="spinner-border"></div>
                </div>
            </div>
        </div>
        <div class="col-2 col-sm-2 col-md-1 col-lg-1 col-xl-1 clear-col" style="cursor:pointer;" (click)="clearSearch()" (keyup.enter)="clearSearch()"
            role="button" (keyup.space)="clearSearch()" tabindex="0"  aria-label="clear search">
            <span class="clear-button-span d-md-none d-none d-lg-block" > {{'journal_home.clear' | translate}} </span>
            <span class="clear-button-span-icon d-lg-none d-md-block">
                <fa-icon class="iconcls" aria-hidden="true" [icon]="['fas', 'xmark']"></fa-icon>
            </span>
        </div>
        <div class="col-2 col-sm-2 col-md-1 col-lg-1 col-xl-1 search-col" style="cursor:pointer ;">
            <span class="search-button-span d-md-none d-none d-lg-block explore-button-search" (click)="showSearchedArticle()" (keyup.enter)="showSearchedArticle()"
                (keyup.space)="showSearchedArticle()" tabindex="0" role="button">
                {{'journal_home.search' | translate}} </span>
            <span class="search-button-span-icon d-lg-none d-md-block" (click)="showSearchedArticle()" (keyup.enter)="showSearchedArticle()"
                (keyup.space)="showSearchedArticle()" tabindex="0">
                <fa-icon class="iconcls" aria-hidden="true" [icon]="['fas', 'magnifying-glass']"></fa-icon>
            </span>
        </div>
    </div>

    <!-- <div class="row article-search-div" role="search" *ngIf="selectDiv">
        <div class="col-1 select-col">
            <select class="custom-select" formControlName="journalSelect" (change)="getJournalSelected()">
                <option *ngFor="let journals of journalData" value={{journals}}>{{journals}}</option>
            </select>
        </div>
        <div class="col-9 search-box-col">
            <div class="input-group search-box">
                <div class="input-group-append search-icon-div">
                    <span class="input-group-text" id="basic-addon11"><i class="bi bi-search"></i></span>
                </div>
                <input type="text" class="form-control text-box" formControlName="searchValue"
                    placeholder="Enter keyword, title, author or ISBN" aria-label="search"
                    aria-describedby="basic-addon11" (keyup)="searchArticle()" (focusout)="searchLoader = false;">
                <div *ngIf="searchLoader">
                    <div class="spinner-border"></div>
                </div>
            </div>
        </div>
        <div class="col-1 clear-col" style="cursor:pointer;" (click)="clearSearch()" (keyup.enter)="clearSearch()"
            role="button" (keyup.space)="clearSearch()" tabindex="0">
            <span class="clear-button-span"> {{'journal_home.clear' | translate}} </span>
            <span class="clear-button-span-icon">
                <fa-icon class="iconcls" aria-hidden="true" [icon]="['fas', 'xmark']"></fa-icon>
            </span>
        </div>
        <div class="col-1 search-col" style="cursor:pointer ;">
            <span class="search-button-span d-md-none d-lg-block" (click)="showSearchedArticle()" (keyup.enter)="showSearchedArticle()"
                (keyup.space)="showSearchedArticle()" tabindex="0" role="button">
                {{'journal_home.search' | translate}} </span>
                <fa-icon class="iconcls d-lg-none" aria-hidden="true" [icon]="['fas', 'search']" ></fa-icon> -->

                
            <!-- <span class="search-button-span-icon" (click)="showSearchedArticle()" (keyup.enter)="showSearchedArticle()"
                (keyup.space)="showSearchedArticle()" tabindex="0">
                <fa-icon class="iconcls" aria-hidden="true" [icon]="['fas', 'magnifying-glass']"></fa-icon>
            </span> -->
        <!-- </div>
    </div> -->
</form>